<template>
  <footer :class="{ 'brdr-top-1 brdr-cl-secondary': isCheckoutPage }">
    <newsletter class=" flex brdr-bottom-1 brdr-cl-dark" v-if="!isCheckoutPage" />
    <div
      class="footer-links flex pt30 pb60 px40 bg-cl-transparent"
      v-if="!isCheckoutPage"
    >
      <div class="container">
        <div class="row m0 center-xs between-md">
          <div class="col-12 col-lg-2 col-xl-2"></div>
          <div class="col-12 col-lg-2 col-xl-3 footer__logo-wrapper">
            <img src="/assets/blackpoint-logo.svg" alt="footer logo" />
            <p class="footer__copy m0">Copyright © 2021</p>
          </div>

          <div class="footer-links__box col-12 col-sm-6 col-lg start-md between-md between-xs no-mobile">
            <cms-block-menu :identifier="'m_FOOTER_MENU_ABOUT'" li-class="footer-links__elem" ul-class="footer-links__list" />
          </div>
          <div class="footer-links__box col-12 col-sm-6 col-lg start-md between-md between-xs no-mobile">
            <cms-block-menu :identifier="'m_FOOTER_MENU_PRODUCT'" li-class="footer-links__elem" ul-class="footer-links__list" />
          </div>

          <div class="footer-links__box col-12 col-sm-6 col-lg start-md between-md between-xs no-mobile">
            <cms-block-menu :identifier="'m_FOOTER_MENU_SECURITY'" li-class="footer-links__elem" ul-class="footer-links__list" />
          </div>

          <div class="footer-links__box col-12 col-sm-6 col-lg start-md between-md between-xs no-mobile">
            <cms-block-menu :identifier="'m_FOOTER_MENU_ACCOUNT'" li-class="footer-links__elem" ul-class="footer-links__list" />
          </div>

          <div class="col-12 col-lg-2 col-xl-1"></div>
          
        </div>

        <div class="row social mt30">
        </div>
      </div>
    </div>
    <div class="py15 px25 brdr-top-1 brdr-cl-secondary bg-cl-white footer-bottom" style="display:flex;justify-content: flex-end;">
      <cms-block-chunk :identifier="'c_POWERED_BY'" />
    </div>
    <back-to-top :bottom="bottom" right="20px" visibleoffset="200">
      <button type="button" class="btn-top button no-outline brdr-none cl-white bg-cl-mine-shaft :bg-cl-th-secondary py10 px10">
        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M23.245 20l-11.245-14.374-11.219 14.374-.781-.619 12-15.381 12 15.391-.755.609z" fill="white" />
        </svg>
      </button>
    </back-to-top>
  </footer>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { currentStoreView, localizedRoute } from '@vue-storefront/core/lib/multistore'
import CurrentPage from 'theme/mixins/currentPage'
import LanguageSwitcher from '../../LanguageSwitcher.vue'
import Newsletter from 'theme/components/core/blocks/Footer/Newsletter'
import BackToTop from 'theme/components/core/BackToTop'
import { getPathForStaticPage } from 'theme/helpers'
import CmsBlockMenu from 'theme/components/core/blocks/Cms/BlockMenu'
import CmsBlockChunk from 'theme/components/core/blocks/Cms/BlockChunk'
import config from 'config'

export default {
  mixins: [CurrentPage, CmsBlockMenu],
  name: 'MainFooter',
  methods: {
    goToAccount () {
      this.$bus.$emit('modal-toggle', 'modal-signup')
    },
    getLinkFor (path) {
      return localizedRoute(getPathForStaticPage(path))
    }
  },
  computed: {
    ...mapGetters({
      isLogged: 'user/isLoggedIn'
    }),
    ...mapState({
      bottom: state => state.uiStore.bottom
    }),
    multistoreEnabled () {
      return config.storeViews.multistore
    },
    getVersionInfo () {
      return `v${process.env.__APPVERSION__} ${process.env.__BUILDTIME__}`
    }
  },
  components: {
    Newsletter,
    LanguageSwitcher,
    BackToTop,
    'cms-block-menu': CmsBlockMenu,
    'cms-block-chunk': CmsBlockChunk
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-secondary: color(secondary);

.icon {
  transition: 0.3s all;
}

.social-icon {
  width: 30px;
  height: 30px;

  &:hover,
  &:focus,
  &:active {
    .icon {
      fill: $color-secondary;
    }
  }

  svg {
    width: 30px;
  }
}
.links {
  list-style-type: none;
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }
}

.footer-links__list {
  list-style: none;
  padding-left: 0;
  color: #000;
  font-size: 14px;
  margin: 0;

  .footer-links__elem {
    color: #000;
    font-size: 14px;
    padding: 8px 0;

    span {
      color: #000;
    }
    a {
      color: #000;
      font-size: 16px;
      font-weight: 600;
    }
  }
}

.row.social {
  justify-content: center;
}

.bottom-links {
  @media (max-width: 767px) {
    padding: 0;
  }
}

.footer__version-info {
  display: flex;
  color: $color-secondary;
  font-size: 0.7rem;
  @media (min-width: 768px) {
    margin-right: 1rem;
    font-size: 0.8rem;
  }
}

.footer__logo-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  margin-bottom: 2rem;
  min-height: 96px;

  img {
    height: 38px;
    width: 154px;
  }

  @media (min-width: 992px) {
    flex-flow: column;
    align-content: space-between;
    align-items: flex-start;
    height: 100%;
  }
  @media (max-width: 595px) {
    min-height: 76px;
    margin-bottom: 0px !important;
  }
}
.footer__copy {
  font-size: 14px;
  font-family: "Roboto", sans-serif;
}

.underline {
  &:hover {
    color: $color-secondary;
    &:after {
      background-color: $color-secondary;
    }
  }
}
.legal-entity-link {
  text-align: center;
  @media (min-width: 768px) {
    display: none;
  }
}

.privacy-policy-link {
  text-align: right;
  @media (min-width: 768px) {
    display: none;
  }
}

@media (max-width: 595px) {
  .no-mobile {
    display: none;
  }

  .social {
    margin-top: 0;
  }

  .footer-links {
    padding-bottom: 30px;
    padding-right: 20px;
    padding-left: 20px;
  }
}
</style>
